import { Banner } from '../../Api'
import { colors } from '../../Components/consts'

const ASG_IMAGE_BASE_URL = `https://premierlacrosseleague.com/wp-content/uploads/2023`
export const ALL_STAR_IMAGES = {
  logo: `https://premierlacrosseleague.com/wp-content/uploads/2024/06/better-asg-2024-logo-final.webp`,
  votingLogo: `https://premierlacrosseleague.com/wp-content/uploads/2024/06/better-asg-2024-logo-final.webp`,
  teamOne: `https://premierlacrosseleague.com/wp-content/uploads/2024/06/24ASG_EIcon_FullColor.webp`,
  teamTwo: `https://premierlacrosseleague.com/wp-content/uploads/2024/06/24ASG_WIcon_FullColor.webp`,
  skills: `https://premierlacrosseleague.com/wp-content/uploads/2024/06/better-asg-2024-logo-final.webp`,
  votingBanner: `https://premierlacrosseleague.com/wp-content/uploads/2024/06/24ASG_Banner.webp`,
  asgBanner: `https://premierlacrosseleague.com/wp-content/uploads/2024/06/24ASG_Banner.webp`,
  rose: `${ASG_IMAGE_BASE_URL}/06/rose-asg.webp`,
  bg: `${ASG_IMAGE_BASE_URL}/06/background-asg-scaled.webp`,
}

export const SHOW_SKILLS_CHALLENGE_ITEMS = true

export const ALL_STAR_BANNER: Banner = {
  id: 56789,
  sponsor: '',
  location: ['all-star'],
  topUrl: ALL_STAR_IMAGES.asgBanner,
  tags: ['all-star', 'all-star-vote'],
  topLink: '',
  leftSideUrl: '',
  rightSideUrl: '',
  secondaryMobile: '',
  startTime: 13408402234,
  endTime: 13408402234,
}

export const ALL_STAR_VOTE_BANNER: Banner = {
  id: 56791,
  sponsor: '',
  location: ['all-star'],
  topUrl: ALL_STAR_IMAGES.votingBanner,
  tags: ['all-star', 'all-star-vote'],
  topLink: '',
  leftSideUrl: '',
  rightSideUrl: '',
  secondaryMobile: '',
  startTime: 13408402234,
  endTime: 13408402234,
}

export type ASGTeamIds = 'east' | 'west'

export type AllStarTeamTab = {
  order: number
  name: string
  id: ASGTeamIds
  color: string
  img: string
  logo: string
}

export const asgTeams: AllStarTeamTab[] = [
  {
    order: 0,
    name: 'Eastern Conference',
    id: 'east',
    color: colors.yellow,
    img: ALL_STAR_IMAGES.teamOne,
    logo: '',
  },
  {
    order: 1,
    name: 'Western Conference',
    id: 'west',
    color: colors.darkBlue,
    img: ALL_STAR_IMAGES.teamTwo,
    logo: '',
  },
]

export const returnASGCoach = (
  teamSide: 'away' | 'home',
  coachType: 'head' | 'assistant'
) => {
  const now = Date.now() / 1000
  const asgDate = 1720530000
  if (now < asgDate) return ''
  if (teamSide === 'away' && coachType === 'head') return `Bill Tierney (PHI)`
  if (teamSide === 'away' && coachType === 'assistant') return `Dylan Sheridan (PHI)`
  if (teamSide === 'home' && coachType === 'head') return `Chris Bates (UTA)`
  if (teamSide === 'home' && coachType === 'assistant') return `Tony Resch (UTA)`
  return
}
